// extracted by mini-css-extract-plugin
module.exports = {"locationSubTitle":"LocationSearchAutocomplete_locationSubTitle__58Gig","divider":"LocationSearchAutocomplete_divider__h7yj5"};